"use strict";

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Styled = void 0;

var _utils = require("../../../utils");

var _Flex = _interopRequireDefault(require("../../Flex"));

var _styledComponents = require("styled-components");

var _drawer = require("./drawer.inject");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: calc(var(--l-top) - 1);\n\n  width: 100vw;\n  height: 100vh;\n\n  background-color: var(--c-lightest);\n  opacity: 0.25;\n\n  cursor: default;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    position: fixed;\n    ", ";\n\n    z-index: var(--l-top);\n\n    overflow-y: scroll;\n\n    padding: var(--i-regular);\n\n    background-color: var(--c-lightest);\n    color: var(--c-darkest);\n\n    ", ";\n    border-radius: 0;\n\n    ", ";\n\n    ", "\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Drawer = (0, _utils.sc)(_Flex["default"])(function (_ref) {
  var isOpen = _ref.isOpen,
      position = _ref.position;
  return (0, _styledComponents.css)(_templateObject(), _drawer.inject.position({
    position: position,
    isOpen: isOpen
  }), _drawer.inject.border(position), _drawer.inject.dimensions(position), _drawer.inject.transition({
    position: position,
    isOpen: isOpen
  }));
})('Drawer');
var Overlay = (0, _utils.sc)('button')((0, _styledComponents.css)(_templateObject2()))('Overlay');
var Styled = {
  Drawer: Drawer,
  Overlay: Overlay
};
exports.Styled = Styled;